var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HelperMessage',{scopedSlots:_vm._u([{key:"message",fn:function(){return [_vm._v(_vm._s(_vm.msg))]},proxy:true}])},[_c('v-icon',_vm._b({},'v-icon',_vm.iconProps,false),[_vm._v("mdi-help-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }